import { Config } from 'config/envConfig';
import React, { useState } from 'react';
import './styles/supportWidgets.css';

export const ChatAssistant = () => {
    const [isOpen, setIsOpen] = useState(false);
    const supportUrl = Config.SUPPORT_URL;

    const toggleChat = (e) => {
        e.stopPropagation();
        setIsOpen((prev) => !prev);
    };

    const closeChat = (e) => {
        if (
            isOpen &&
            !e.target.closest('.support-iframe') &&
            !e.target.closest('.support-button')
        ) {
            setIsOpen(false);
        }
    };

    // Attach click listener to close iframe when clicked outside
    React.useEffect(() => {
        document.addEventListener('click', closeChat);
        return () => document.removeEventListener('click', closeChat);
    }, [isOpen]);

    return (
        <>
            <button
                className='support-button'
                title='🙋🏻‍♂️ Ask me something'
                onClick={toggleChat}
            >
                🤖
            </button>

            <iframe
                className={`support-iframe ${isOpen ? 'open' : ''}`}
                src={supportUrl}
                allow='microphone; autoplay; clipboard-read; clipboard-write; encrypted-media;'
                title='Support Chat'
            />
        </>
    );
};
